import { Token } from 'symbiosis-js-sdk'

import Spinner from '~/components/Spinner'
import { renderAmount } from '~/lib/helpers'
import { FarmingAPR } from '~/lib/useFarmingAPR'

import styles from './APRValue.pcss'

interface Props {
	tokenA: Token
	tokenB: Token
	farmingAPR: FarmingAPR
}

function APRValue({ tokenA, tokenB, farmingAPR }: Props) {
	if (farmingAPR.status === 'pending') {
		return <Spinner className={styles.spinner} />
	}

	const apr = farmingAPR.apy(tokenB.chainFromId, tokenA.chainId)

	return <span>{apr ? `${renderAmount(apr, 2)}%` : '-'}</span>
}

export default APRValue
